export type OutboundFetchErrorLevel = 'error' | 'warn' | 'info';

export type OutboundFetchErrorLogEvent = {
  body?: string;
  errorCode?: string;
  errorType?: string;
  level?: OutboundFetchErrorLevel;
  method: string;
  statusCode?: number;
  url: string;
};

export type OutboundFetchErrorLogger = (event: OutboundFetchErrorLogEvent) => void | Promise<void>;

let outboundFetchErrorLogger: OutboundFetchErrorLogger | null = null;

export function setOutboundFetchErrorLogger(logger: OutboundFetchErrorLogger | null): void {
  outboundFetchErrorLogger = logger;
}

export function emitOutboundFetchError(event: OutboundFetchErrorLogEvent): void {
  if (typeof window !== 'undefined') return;
  if (!outboundFetchErrorLogger) return;
  void outboundFetchErrorLogger(event);
}
